import { Client } from '@/utilities/api/Client';
import { DashboardEndpoint } from '@api/endpoints/DashboardEndpoint';
import { PointsHistoryEndpoint } from '@api/endpoints/PointsHistoryEndpoint';
import { RetailerEndpoint } from "@api/endpoints";
import { QueryUtil } from "@/utilities/Query";

export class DashboardApi {
  static getBooking (
    accessToken: string,
    bookingId: string,
  ): Promise<DashboardEndpoint.GetBooking.Response> {
    const url = `dashboard/${accessToken}/bookings/${bookingId}`;
    return Client(url);
  }

  static getData (
    accessToken: string,
    notificationId?: string,
  ): Promise<DashboardEndpoint.GetData.Response> {
    const url = notificationId
      ? `dashboard/${accessToken}?notificationId=${notificationId}`
      : `dashboard/${accessToken}`;
    return Client(url);
  }

  static getFarmerRewards (
    accessToken: string,
    programId: string,
    forFarmerOnly?: boolean,
  ): Promise<DashboardEndpoint.GetFarmerRewards.Response> {
    const queryString = QueryUtil.stringify({ programId, ...(forFarmerOnly && { forFarmerOnly }) });
    return Client(`dashboard/${accessToken}/farmer-rewards?${queryString}`);
  }

  static getPointsKPIs (
    accessToken: string,
    rewardsProgramId: string,
  ): Promise<RetailerEndpoint.GetPointsKPIsByCustomer.Response> {
    return Client(`dashboard/${accessToken}/points-kpis?rewardsProgramId=${rewardsProgramId}`);
  }

  static listAllOrders (
    accessToken: string,
    query?: DashboardEndpoint.ListAllOrders.Query,
  ): Promise<DashboardEndpoint.ListAllOrders.Response> {
    const queryString = QueryUtil.stringify(query ?? {});
    const url = `dashboard/${accessToken}/orders${queryString ? `?${queryString}` : ''}`;
    return Client(url);
  }

  static listRelevantSalespersons (
    accessToken: string,
  ): Promise<DashboardEndpoint.ListRelevantSalespersons.Response> {
    return Client(`dashboard/${accessToken}/salespersons`);
  }

  static listBookings (
    accessToken: string,
    query?: DashboardEndpoint.ListBookings.Query,
  ): Promise<DashboardEndpoint.ListBookings.Response> {
    return Client(`dashboard/${accessToken}/bookings/list`, {
      method: 'POST',
      body: query ?? {},
    });
  }

  static listOrderPointActivity (
    userId: string,
    query?: PointsHistoryEndpoint.List.Query,
  ): Promise<PointsHistoryEndpoint.List.Response> {
    const queryString = QueryUtil.stringify(query ?? {});
    const url = `users/${userId}/points-activity${queryString ? `?${queryString}` : ''}`;
    return Client(url);
  }
}
